module.exports = __webpack_public_path__ + "img/47.9f81f9e1.jpg";